import { PRODUCT_NAME_FULL } from "@/config";
import React from "react";

// FAQ copy ported verbatim from the design's faqData.
const FAQ_DATA: ReadonlyArray<{ q: string; a: string }> = [
  {
    q: "Entscheidet die KI über meine Angebote?",
    a: "Nein. Die KI liest E-Mails und formuliert Entwürfe — mehr nicht. Ob eine Anfrage angebotsfähig ist, welche Rückfragen gestellt werden und welche Hinweise gelten, entscheidet Ihr deterministisches Regelwerk. Und gesendet wird erst, wenn Ihr Team freigibt.",
  },
  {
    q: "Was passiert bei unklaren oder widersprüchlichen Anfragen?",
    a: `Sie landen bei einem Menschen. Widersprüchliche Gästezahlen, mehrere Veranstaltungen in einer E-Mail, unplausible Termine: Solche Fälle markiert ${PRODUCT_NAME_FULL} zur Prüfung — es rät nie.`,
  },
  {
    q: "Wie aufwendig ist die Einführung?",
    a: `Überschaubar: Ihr Postfach bleibt, wie es ist — ${PRODUCT_NAME_FULL} liest eingehende Anfragen mit. Das Regelwerk startet mit Ihrer heutigen Praxis; wir übersetzen sie gemeinsam in geprüfte Regeln, Schritt für Schritt.`,
  },
  {
    q: "Wo liegen unsere Daten?",
    a: "In Ihrer eigenen Instanz, ausgelegt für Hosting in der EU. Wie Datenhaltung, Löschfristen und Auftragsverarbeitung konkret aussehen, legen wir in der Demo transparent offen.",
  },
  {
    q: "Sendet das System E-Mails automatisch?",
    a: "Nein — konstruktionsbedingt: Einen Auto-Versand gibt es im System nicht. Jede ausgehende E-Mail wird von einem Menschen geprüft, bei Bedarf angepasst und erst dann gesendet.",
  },
];

/** Single-open accordion; the first question starts expanded, like the design. */
export function Faq() {
  const [openFaq, setOpenFaq] = React.useState<number | null>(0);

  return (
    <section id="faq" style={{ padding: "clamp(60px,8vw,100px) 24px" }}>
      <div style={{ maxWidth: "760px", margin: "0 auto" }}>
        <h2 style={{ margin: "0 0 36px", fontSize: "clamp(26px,3.4vw,36px)", fontWeight: 600, lineHeight: 1.2, letterSpacing: "-.01em" }}>Häufige Fragen</h2>
        <div style={{ display: "flex", flexDirection: "column" }}>
          {FAQ_DATA.map((item, index) => {
            const open = openFaq === index;
            return (
              <div key={item.q} style={{ borderBottom: "1px solid rgba(var(--ink-rgb),.11)" }}>
                <button
                  type="button"
                  className="faq-toggle"
                  aria-expanded={open}
                  onClick={() => setOpenFaq(open ? null : index)}
                >
                  <span style={{ fontSize: "16.5px", fontWeight: 600, color: "var(--ink)", lineHeight: 1.4 }}>{item.q}</span>
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ transition: "transform .3s ease", transform: open ? "rotate(180deg)" : "rotate(0deg)", color: "var(--muted-2)", flex: "none" }}><path d="M6 9l6 6 6-6"></path></svg>
                </button>
                <div style={{ display: "grid", gridTemplateRows: open ? "1fr" : "0fr", transition: "grid-template-rows .32s ease" }}>
                  <div style={{ overflow: "hidden", minHeight: 0 }}>
                    <p style={{ margin: 0, padding: "0 4px 20px", fontSize: "15.5px", lineHeight: 1.68, color: "var(--text)", maxWidth: "60ch", textWrap: "pretty" }}>{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
